// extracted by mini-css-extract-plugin
export default {"wrapper":"input-radio-module--wrapper--3W-FR","input":"input-radio-module--input--21Tnz","icon":"input-radio-module--icon--74OMY"};